class MapWinefarmers extends HTMLElement {
  connectedCallback() {
    this.mapType = this.dataset.mapType;
    this.mapEl = this.querySelector('.map');
    this.mapItems = this.querySelectorAll('g[data-item]');
    this.tooltip = this.querySelector('[data-map-winefarmers-tooltip]');
    this.tooltipTitle = this.querySelector('[data-map-winefarmers-tooltip-title]');
    this.tooltipMeta = this.querySelector('[data-map-winefarmers-tooltip-meta]');

    this.itemData = {};
    this.querySelectorAll('script[type="application/json"]').forEach((el) => {
      Object.assign(this.itemData, JSON.parse(el.textContent));
    });

    this.initTooltip();

    if (this.mapType === 'eu') {
      this.initEuMap();
    } else if (this.mapType && this.mapType !== 'none') {
      this.initCountryMap();
    }
  }

  addActivateListener(element, callback) {
    element.addEventListener('click', callback);
    element.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        callback();
      }
    });
  }

  initTooltip() {
    if (!this.tooltip || !this.mapEl) return;

    this.mapItems.forEach((item) => {
      const titleEl = item.querySelector('title');
      const name = titleEl ? titleEl.textContent : '';

      item.addEventListener('mouseenter', (e) => {
        this.showTooltip(name, this.itemData[item.dataset.item], e);
      });

      item.addEventListener('mousemove', (e) => {
        this.positionTooltip(e);
      });

      item.addEventListener('mouseleave', () => {
        this.hideTooltip();
      });

      item.addEventListener('focus', () => {
        this.showTooltipOnFocus(name, this.itemData[item.dataset.item], item);
      });

      item.addEventListener('blur', () => {
        this.hideTooltip();
      });
    });
  }

  updateTooltipContent(name, meta) {
    this.tooltipTitle.textContent = name;
    if (this.tooltipMeta) {
      const text = this.formatMeta(meta);
      this.tooltipMeta.textContent = text;
      this.tooltipMeta.hidden = !text;
    }
  }

  showTooltip(name, meta, e) {
    this.updateTooltipContent(name, meta);
    this.tooltip.classList.add('is-visible');
    this.positionTooltip(e);
  }

  positionTooltip(e) {
    const mapRect = this.mapEl.getBoundingClientRect();
    let x = e.clientX - mapRect.left;
    let y = e.clientY - mapRect.top;

    this.tooltip.style.left = `${x}px`;
    this.tooltip.style.top = `${y}px`;

    const tipRect = this.tooltip.getBoundingClientRect();

    if (tipRect.top < 0) {
      y = e.clientY - mapRect.top + tipRect.height + 16;
      this.tooltip.style.top = `${y}px`;
    }

    if (tipRect.left < 0) {
      this.tooltip.style.left = `${tipRect.width / 2}px`;
    } else if (tipRect.right > window.innerWidth) {
      this.tooltip.style.left = `${mapRect.width - tipRect.width / 2}px`;
    }
  }

  showTooltipOnFocus(name, meta, element) {
    this.updateTooltipContent(name, meta);

    const mapRect = this.mapEl.getBoundingClientRect();
    const elRect = element.getBoundingClientRect();
    const x = elRect.left + elRect.width / 2 - mapRect.left;
    const y = elRect.top - mapRect.top;

    this.tooltip.style.left = `${x}px`;
    this.tooltip.style.top = `${y}px`;
    this.tooltip.classList.add('is-visible');
  }

  formatMeta(meta) {
    if (!meta) return '';
    const farmerLabel = meta.farmers === 1 ? 'wijnboer' : 'wijnboeren';
    if (meta.regions !== undefined) {
      const regionLabel = meta.regions === 1 ? 'regio' : "regio's";
      return `${meta.regions} ${regionLabel} · ${meta.farmers} ${farmerLabel}`;
    }
    return `${meta.farmers} ${farmerLabel}`;
  }

  hideTooltip() {
    this.tooltip.classList.remove('is-visible');
  }

  initEuMap() {
    this.mapItems.forEach((item) => {
      const data = this.itemData[item.dataset.item];
      if (!data || !data.url) return;

      this.addActivateListener(item, () => {
        window.location.href = data.url;
      });
    });
  }

  initCountryMap() {
    this.selectedRegion = null;
    this.farmers = this.querySelectorAll('.map-winefarmers__card[data-regions]');
    this.dropdown = this.querySelector('[data-region-filter]');

    this.mapItems.forEach((item) => {
      this.addActivateListener(item, () => {
        this.toggleRegion(item.dataset.item);
      });
    });

    if (this.dropdown) {
      this.dropdown.addEventListener('change', () => {
        this.selectRegion(this.dropdown.value || null);
      });
    }
  }

  toggleRegion(regionHandle) {
    this.selectRegion(this.selectedRegion === regionHandle ? null : regionHandle);
  }

  selectRegion(regionHandle) {
    this.selectedRegion = regionHandle;

    if (this.mapEl) {
      this.mapEl.dataset.selected = regionHandle || '';
    }

    if (this.dropdown) {
      this.dropdown.value = regionHandle || '';
    }

    this.farmers.forEach((farmer) => {
      if (!regionHandle) {
        farmer.hidden = false;
        return;
      }
      const regions = (farmer.dataset.regions || '').split(',');
      farmer.hidden = !regions.includes(regionHandle);
    });

    this.mapItems.forEach((item) => {
      if (!regionHandle) {
        item.classList.remove('is-selected', 'is-dimmed');
      } else if (item.dataset.item === regionHandle) {
        item.classList.add('is-selected');
        item.classList.remove('is-dimmed');
      } else {
        item.classList.add('is-dimmed');
        item.classList.remove('is-selected');
      }
    });
  }
}

customElements.define('map-winefarmers', MapWinefarmers);
